import { createStore } from 'owa-satcheljs';
import { getZoomIncrementFromStorage } from '../utils/localStorage';
import { ZOOM_INCREMENTS } from '../utils/constants';
import type ZoomStore from './schema/ZoomStore';
import type ZoomViewState from './schema/ZoomViewState';

const initialZoomStore: ZoomStore = {
    zoomViewStates: new Map<string, ZoomViewState>([]),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getZoomIncrementFromStorage called at module scope is not allowed. This may cause unwanted side effects. */
    zoomIncrementIndex: ZOOM_INCREMENTS.indexOf(getZoomIncrementFromStorage()),
};

const getStore: () => ZoomStore = createStore<ZoomStore>('zoomStore', initialZoomStore);
export default getStore;
export { getStore };

export const getZoomViewState = (context: string): ZoomViewState | undefined => {
    if (!getStore().zoomViewStates.has(context)) {
        getStore().zoomViewStates.set(context, { isCalloutVisible: false });
    }

    return getStore().zoomViewStates.get(context);
};
